<template>
  <div class="home">

    <el-carousel class="carousel" height="300px" motion-blur>
      <el-carousel-item v-for="(image, index) in bannerImages" :key="index">
        <el-image style="width: 100%; height: 100%" :src="image" fit="cover" />
      </el-carousel-item>
    </el-carousel>

    <div class="app-description">
      <h2>应用介绍</h2>
      <h3>TOYNAME是一款专为准新人设计的全方位婚礼信息平台，致力于帮助用户轻松规划和筹备他们的完美婚礼。</h3>
    </div>
    <div class="button-group">
      <el-button type="success" @click="downloadApp" class="button">下载应用</el-button>
      <!-- <el-button type="success" @click="clickShopInfo" class="button">商家登录</el-button> -->
    </div>
    <div class="image-gallery">
      <div class="image-item" v-for="(item, index) in imageItems" :key="index">
        <el-image style="width: 200px; height: 100px;" :src="item.img" fit="cover" />
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'HomePage',
  data() {
    return {
      bannerImages: [
        require('@/assets/banner1.jpg'),
        require('@/assets/banner2.jpg'),
      ],
      imageItems: [
        { img: require('@/assets/tab1.jpg') },
        { img: require('@/assets/tab2.jpg') },
        { img: require('@/assets/tab3.jpg') },
        { img: require('@/assets/tab4.jpg') },
      ],
    };
  },
  methods: {
    downloadApp() {
      window.open('https://app.uqrixayli.com/apk/Uqrixayli.apk', '_blank');
    },
   




  },
};
</script>

<style scoped>
.home {
  text-align: center;
  max-width:1080px;
  margin: 0 auto;
}

.carousel {
  border-radius: 5px;
  margin-top: 20px;
}

.app-description {
  margin: 30px 0;
}

.app-description h2 {
  font-size: 1.5em;
  margin-bottom: 10px;
}

.image-gallery {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.el-image {
  border-radius: 5px;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.button {
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 1em;
}

/* 指示器样式 */
.swiper-pagination {
  bottom: 10px;
}
</style>
